import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "loadMoreButton"]

  connect() {
    this.autoScrollEnabled = true
    this.isLoadingMoreMessages = false

    // Observar cambios en el DOM dentro del contenedor
    this.observer = new MutationObserver(() => {
      if (this.autoScrollEnabled && !this.isLoadingMoreMessages) {
        this.scrollToBottom()
      }
    })

    // Observe the container
    this.mainObserver()

    // Scroll to bottom when chat is first loaded
    // Use setTimeout to ensure DOM is fully rendered
    setTimeout(() => {
      this.scrollToBottom()
    }, 100)
  }

  mainObserver() {
    this.observer.observe(this.containerTarget, {
      childList: true,
      subtree: true
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.hasLoadMoreButtonTarget) {
      this.loadMoreButtonTarget.removeEventListener('click', this.handleLoadMoreClick.bind(this))
    }
    if (this.messageObserver) {
      this.messageObserver.disconnect()
    }
  }

  scrollToBottom() {
    const container = this.containerTarget

    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }

  disableAutoScroll() {
    this.autoScrollEnabled = false
  }

  enableAutoScroll() {
    this.autoScrollEnabled = true
  }

  handleLoadMoreClick(event) {

    // Check the last message in the container and sa
    const chatContainer = this.containerTarget
    this.messagesContainer = chatContainer.lastElementChild
    this.lastMessage = this.messagesContainer.firstElementChild


    // Mark that we are loading more messages
    this.isLoadingMoreMessages = true

    // Deshabilitar el scroll automático temporalmente
    this.disableAutoScroll()

    // Call the setupMessageObserver
    this.setupMessageObserver()
  }

  setupMessageObserver() {
    // Observar cambios en el contenedor de mensajes
    this.messageObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.restoreScrollPosition()
          this.messageObserver.disconnect() // Desconectar después de restaurar
        }
      })
    })

    // Observar el contenedor de mensajes
    const containerId = this.containerTarget.id
    const chatroomId = containerId.replace('chat_container_', '')
    const messagesContainer = this.containerTarget.querySelector(`#messages_${chatroomId}`)

    if (messagesContainer) {
      this.messageObserver.observe(messagesContainer, {
        childList: true,
        subtree: true
      })
    }
  }

  restoreScrollPosition() {
    // Disable the main observer temporarily
    this.observer.disconnect()

    // Usar requestAnimationFrame + timeout para asegurar que el DOM se haya actualizado completamente
    requestAnimationFrame(() => {
      setTimeout(() => {
        // Scroll to the last message position
        this.lastMessagePosition = this.lastMessage.offsetTop

        this.containerTarget.scrollTop = this.lastMessagePosition

        // Enable auto scroll for new messages
        this.enableAutoScroll()

        // Mark that we are not loading more messages
        this.isLoadingMoreMessages = false

        // Reconnect the observer after a delay to ensure scroll position is stable
        setTimeout(() => {
          this.observer.observe(this.containerTarget, {
            childList: true,
            subtree: true
          })
        }, 500) // Wait 500ms before reconnecting
      }, 10)
    })
  }
}
